import React, { ForwardedRef } from "react";

import { MeetingSessionMediaState, MeetingSessionStatus } from "@kalyzee/kast-web-sdk/http";
import { Meeting, MeetingSession, MeetingSessionMedia } from "@kalyzee/kast-web-sdk/websocket";
import { getFormattedUserFromMeetingSession } from "../../helpers/meeting";

import { Loading, UserAvatar } from "@kalyzee/kast-web-sdk/web-components";
import styles from "./MeetingPlayerDataOverlay.module.css";

export interface MeetingPlayerDataOverlayProps {
  meeting?: Meeting;
  session?: MeetingSession;
  mediaSession?: MeetingSessionMedia;
  mediaStream?: MediaStream;
  videoIsDisabled?: boolean;
  videoIsReady?: boolean;
  poster?: string;
  style?: React.CSSProperties;
  className?: string;
}

export interface MeetingPlayerDataOverlayRef {}

export const MeetingPlayerDataOverlay = React.forwardRef(
  (
    { meeting, session, mediaSession, mediaStream, videoIsDisabled, videoIsReady, poster, style, className }: MeetingPlayerDataOverlayProps,
    forwardRef: ForwardedRef<MeetingPlayerDataOverlayRef>
  ) => {
    if (!meeting || !session) return null;
    const classes = [styles.container];
    if (className) classes.push(className);
    const { avatar, fullname } = session ? getFormattedUserFromMeetingSession(session, meeting) : { avatar: undefined, fullname: "-" };
    const disconnected = session?.status !== MeetingSessionStatus.RUNNING;
    const hideAvatar = poster && mediaSession?.video.enabled && !disconnected;
    const mediaIsReady = mediaSession?.state === MeetingSessionMediaState.READY
    let message: React.ReactNode = <Loading style={{ "--loading-svg-color": "rgba(236, 105, 74, 0.5)" } as any} width={50} height={10} />;
    if (disconnected) {
      classes.push(styles.disconnected);
      message = "Déconnecté";
    } else {
      if (!mediaSession) {
        message = <Loading style={{ "--loading-svg-color": "rgba(235, 212, 146, 0.5)" } as any} width={50} height={10} />;
      } else {
        if ([MeetingSessionMediaState.WAITING, MeetingSessionMediaState.CAPTURING].includes(mediaSession.state)) {
          message = <Loading style={{ "--loading-svg-color": "white" } as any} width={50} height={10} />;
        }
        if (mediaSession.state === MeetingSessionMediaState.PUBLISHING) {
          message = <Loading style={{ "--loading-svg-color": "rgba(90, 160, 215, 0.5)" } as any} width={50} height={10} />;
        }
        if (mediaIsReady) {
          if (mediaStream) {
            if (!videoIsReady) {
              message = <Loading style={{ "--loading-svg-color": "rgba(255, 255, 255, 0.5)" } as any} width={50} height={10} />;
            } else {
              if (!mediaSession.video.enabled) {
                classes.push(styles.blackBackground);
                message = "La caméra est désactivée";
              } else if (videoIsDisabled) return <div className={styles.notReadyOverlay} />;
              else return null;
              if (videoIsReady) {
                if (!mediaSession.video.enabled) {
                  classes.push(styles.blackBackground);
                  message = "La caméra est désactivée";
                } else if (videoIsDisabled) return <div className={styles.notReadyOverlay} />;
                else return null;
              }
            }
          } else {
            message = <Loading style={{ "--loading-svg-color": "rgba(229, 231, 143, 0.5)" } as any} width={50} height={10} />;
          }
        }
      }
    }

    const renderPoster = () => {
      if ((disconnected || !mediaIsReady) && poster) {
        return (
          <div className={styles.posterContainer}>
             <img src={poster} alt="poster" />
             <div/>
          </div>
        );
      }
      return null;
    };

    return (
      <div className={classes.join(" ")} style={style}>
        {renderPoster()}
        {!hideAvatar && <UserAvatar style={{ width: "60px", height: "60px" }} image={avatar} username={fullname} />}
        {message}
      </div>
    );
  }
);
